import React from 'react';
import { useSelector } from 'react-redux';
import './favorites-content.scss';
import ContentTabGroup from './content-tab-group/content-tab-group';
import BackButtonNavigationTracking from '../../utils/back-button-helper';
import { IRootState } from '../../app/store';
import BackButton from '../../components/back-button/back-button';
import { hasFailed } from '../../../libs/utils/constants/async-status';
import { selectUserFavoriteContentAsyncStatus } from './skills-favorite-tab/skills-favorite-tab-selector';

const FavoritesContent = () => {
    const baseClassName = 'favorites-content';
    const historyStack = useSelector(
        (state: IRootState) => state.navigation.history
    );
    const userFavoriteContentAsyncStatus = useSelector(
        selectUserFavoriteContentAsyncStatus
    );

    const canGoBack = historyStack.length > 1;

    return (
        <div className={`${baseClassName}`}>
            {canGoBack && window.history.length > 0 && <BackButton />}
            {!hasFailed(userFavoriteContentAsyncStatus) && (
                <h1
                    id="content"
                    tabIndex={-1}
                    className={`${baseClassName}__sub-header`}
                >
                    Favorites
                </h1>
            )}
            <ContentTabGroup />
        </div>
    );
};
export default BackButtonNavigationTracking(
    'Favorites-Content',
    FavoritesContent
);
